import { kpiBasisLabel, kpiBasisNote, type KpiCardKey } from "@shared/kpi-basis";
import { cn } from "@/lib/utils";

/**
 * The line under a card's title saying which log it read and which date it filtered by.
 *
 * Both the label and the routing come from `shared/kpi-basis.ts`, so a card cannot claim
 * a basis the server isn't using. Without it, two cards legitimately disagreeing —
 * Invoiced Commission counting money that hasn't paid, Paid Commission counting a period
 * that isn't the same one — reads as a bug worth chasing.
 */
export function KpiBasisLabel({
  card,
  override,
  className,
}: {
  card: KpiCardKey;
  /** For a row whose basis is configurable and therefore comes from the server. */
  override?: string;
  className?: string;
}) {
  const label = override ?? kpiBasisLabel(card);
  if (!label) return null;
  return (
    <p
      className={cn(
        "text-[10px] font-normal normal-case tracking-normal text-muted-foreground/70",
        className,
      )}
    >
      {label}
    </p>
  );
}

/** The same table's caveat, appended inside a card's existing tooltip. */
export function KpiBasisNote({
  card,
  override,
}: {
  card: KpiCardKey;
  override?: string;
}) {
  const note = override ?? kpiBasisNote(card);
  if (!note) return null;
  return <p className="mt-1.5">{note}</p>;
}
